"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWithHtml = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _textWithHtmlClasses = require("./textWithHtmlClasses");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const TextWithHtml = ({
  html,
  className,
  showMore,
  isOverflowVisible: isOverflowVisibleProp,
  testId,
  elementsProps,
  maxLines: maxLinesProp,
  topChildren,
  bottomChildren
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    open,
    onToggle
  } = (0, _presentationHooks.useDisclose)();
  const rootClassName = (0, _clsx.default)(_textWithHtmlClasses.textWithHtmlClasses.root, className);
  const textElementRef = (0, _react.useRef)(null);
  const {
    isOverflow
  } = (0, _utils.useOverflow)({
    ref: textElementRef
  });
  const showMoreText = (0, _react.useMemo)(() => (0, _utils.getShowMoreText)(showMore, open), [open, showMore]);
  const isOverflowVisible = isOverflowVisibleProp ?? showMore === undefined;
  const maxLines = open ? undefined : maxLinesProp;
  const shouldShowToggleButton = Boolean(showMore && (isOverflow || open) && showMoreText);
  const htmlContent = (0, _react.useMemo)(() => {
    if (!html) {
      return null;
    }
    return (0, _utils.decodeHtml)({
      html,
      elementsProps: (0, _deepmerge.default)(_constants.defaultElementsProps ?? {}, elementsProps ?? {})
    });
  }, [elementsProps, html]);
  if (htmlContent === null && topChildren == null && bottomChildren == null) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: rootClassName,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Text, {
      ref: textElementRef,
      className: _textWithHtmlClasses.textWithHtmlClasses.text,
      isOverflowVisible: isOverflowVisible,
      maxLines: maxLines,
      "data-testid": testId ?? getTestId(_constants.TEXT_WITH_HTML),
      children: [topChildren, htmlContent, bottomChildren]
    }), shouldShowToggleButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ToggleButton, {
      className: _textWithHtmlClasses.textWithHtmlClasses.toggleButton,
      "data-testid": _constants.READ_MORE,
      onClick: onToggle,
      ...showMore?.typographyProps,
      children: showMoreText
    }) : null]
  });
};
exports.TextWithHtml = TextWithHtml;
//# sourceMappingURL=TextWithHtml.js.map